<template>
    <FlyerlineModal ref="modal" :name="name" @close="handleClose" >
        <div class="sky-form">
            <!--    {{addresses}}-->
            <div class="sky-form__row">
                <template v-for="field in addressTextFields">
                    <div class="sky-form__columns max-w-50@medium">
                        <label :for="p(field.name)">{{field.caption}}</label>
                        <input v-model="fields[field.name]" type="text" :id="p(field.name)"/>
                    </div>
                </template>
                <div class="sky-form__columns max-w-50@medium">
                  <label>{{"versandaufteilungCountry"|translate}} </label>
                  <input readonly :value="'versandaufteilungCountryCtxt'+contextId|translate"/>
                </div>
                <div class="sky-form__columns">
                    <button @click="confirmAddress" class="btn btn--dark btn--prj-min-x w-100@until-medium float-right">{{'versandaufteilungConfirmNewaddress'|translate}}</button>
                </div>
            </div>
        </div>
    </FlyerlineModal>
</template>

<script>
    import {translatePrj} from "classes/vue-dict-filter";
    import {capitalizeFirstLetter} from "classes/helpers";
    import PrefixId from "mixins/PrefixId";
    import ComponentPromise from "mixins/ComponentPromise"
    import FlyerlineModal from "../../fragments/FlyerlineModal";

    const requiredFields = [ 'firstname', 'lastname', 'addressLine1', 'myZip', 'city']
    export const addressTextFields = [ 'company','department', 'salutation','firstname', 'lastname', 'addressLine1', 'myZip', 'city']
    const prefix = 'versandaufteilung';

    function getTitle(name) {
        return translatePrj(prefix + capitalizeFirstLetter(name)) || "";
    }

    export default {
        name: "TextAddress",
        components: {FlyerlineModal},
        mixins: [ ComponentPromise, PrefixId ],
        created() {
            this.addressTextFields = addressTextFields.map(name => ({name, caption: getTitle(name)}));
            this.name= 'textEditAddress';
        },
        inject: ['globalConfig'],
        data() {
            const textFields = addressTextFields.reduce((obj, item) => {
                obj[item] = ""; return obj}, {});
            return {  fields:{...textFields },
            contextId: this.globalConfig.contextid}
        },
        methods: {
            /** Intendended public use via ref
             *
             * @param data: if existing address is to edit, null if new address
             * @returns {Promise }
             */
            open(data) {

                // Reset fields
                for( let key of Object.keys(this.fields) ){
                    this.fields[key] = "";
                }
                if( data )
                {
                    for( const key of Object.keys(this.fields) )
                    {
                        this.fields[key] = data[key]
                    }
                }
                this.$refs.modal.open()

                this.rejectOldPromise('overlay opened')
                return this.createPromise();

            },
            confirmAddress() {
                // TODO: check non optional fields
                // loop over 
                // forObject.keys(this.fields)
                // key is contained in requiredFields: Check if is not blank

                if (this.resolver) {
                    this.resolver(
                        {
                            deliveryaddress: JSON.parse(JSON.stringify(this.fields)), // Otherwise
                            addressinfoid: -1
                        })
                }
                this.$refs.modal.close()
            },
            handleClose() {
                this.rejectOldPromise("Closed")
            }


        }

    }
</script>

<style scoped>

</style>